import { createSelector } from 'reselect';

import { isPermanentTrial } from '@/resources/supply-migration/helpers';
import { selectSaasMigrationSettings } from '@/resources/supply-migration/selects';

export const isPermanentSelector = createSelector(
  [selectSaasMigrationSettings],
  (supplyMigrationSettings) => isPermanentTrial(supplyMigrationSettings!)
);
